import React, { createContext, useContext, useMemo, useState } from 'react'

const PatientHeaderSizeContext = createContext<{
  height: number
  setHeight: React.Dispatch<React.SetStateAction<number>>
}>({ height: 0, setHeight: () => undefined })

export const PatientHeaderSizeProvider = ({ children }: { children: React.ReactNode }) => {
  const [height, setHeight] = useState(0)
  const value = useMemo(() => ({ height, setHeight }), [height])
  return <PatientHeaderSizeContext.Provider value={value}>{children}</PatientHeaderSizeContext.Provider>
}

export const usePatientHeaderSize = () => useContext(PatientHeaderSizeContext)
